module.exports = __webpack_public_path__ + "img/fw-logo.bd8658d0.png";